/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum UserSortOption {
    MODIFIED_DATE = 'ModifiedDate',
    FIRST_NAME = 'FirstName',
}